import {enableLanguages} from "App/translations";
import {default as i18n} from "i18next";
import {formatPhoneNumberIntl} from 'react-phone-number-input'
import {Language} from "App/constants";

export function createReducer(initialState: any, handlers: any) {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action)
        } else {
            return state
        }
    }
}

export function selectedGlobalLang(): Language {
    return selectedLang(i18n);
}

export function selectedLang(i18n: any): Language {
    return <Language>i18n.languages && i18n.languages[0] || enableLanguages()[0];
}

export function asBoolean(value: any): boolean {
    return value;
}

export function asString(value: any): string {
    return value;
}

export function formatPhone(phone: string): string {
    const label : string = phone.trim();
    return label.startsWith("0")?label:formatPhoneNumberIntl(label);
}

export function isLoginDisabled() {
    return process.env.REACT_APP_DISABLE_LOGIN==="true"||false;
}


// WEBPACK FOOTER //
// ./src/helper.ts